import React, { useState } from 'react';
import Sidebar, { SidebarItem, SidebarItemGroup } from './Sidebar';
import '../App.css';
import Cookies from 'js-cookie';
import { IconButton, Avatar, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, Menu, MenuItem, Box, Typography, Divider, TextField, Select, FormControl, InputLabel, Grid, CircularProgress } from '@mui/material';
import { Outlet, Link, useNavigate } from 'react-router-dom';
// import homeicon from './Assets/images/Home.png';
import { Home as HomeIconLucide, Calendar, Users, Settings as SettingsIconLucide, UserPlus } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { clearTokens } from './Auth/AuthUtil.js';
import { SidebarContext } from './Sidebar';
import { kioskModel } from './Axios/AxiosConfig';
import { toast, Zoom } from 'react-toastify';


function Home() {
    const doctorDetailsCookie = Cookies.get('Doctor_details');
    let Doctor_details = {};

    const location = useLocation();
    const navigate = useNavigate();

    const [logoutOpen, setLogoutOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpenAddUser = () => {
        navigate('/AddUser');
    };


    if (doctorDetailsCookie) {
        try {
            Doctor_details = JSON.parse(doctorDetailsCookie);
        } catch (error) {
            console.log('Error parsing Doctor_details cookie:', error);
        }
    }

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleLogoutClick = () => {
        setLogoutOpen(true);
        handleMenuClose();
    };
    const handleProfileClick = () => {
        handleMenuClose();
        navigate('/profile');
    };


    const handleConfirmLogout = () => {
        clearTokens();
        setLogoutOpen(false);
        navigate('/login');
    };

    // Cancel logout
    const handleCancel = () => {
        setLogoutOpen(false);
    };

    let kiosk_details = {};

    let kiosk_detailsCookie = Cookies.get('kiosk_details');

    if (kiosk_detailsCookie) {
        try {
            kiosk_details = JSON.parse(kiosk_detailsCookie);
        } catch (error) {
            console.log('Error parsing kiosk_details cookie:', error);
        }
    }
    return (
        <div className="home-container flex">
            <Sidebar Doctor_details={Doctor_details}>
                {[
                    { path: '/', label: 'Home', IconCmp: HomeIconLucide },
                    { path: '/Appointments', label: 'Appointments', IconCmp: Calendar },
                    { path: '/Patientlist', label: 'Patient list', IconCmp: Users },
                ].map(({ path, label, IconCmp }) => (
                    <Link to={path} key={path}>
                        <SidebarItem
                            icon={<IconCmp size={28} className="mx-0.5" style={{ color: "var(--themePrimaryColor, #312110)" }} />}
                            text={label}
                            active={location.pathname === path}
                        />
                    </Link>
                ))}

                <SidebarItemGroup
                    icon={<SettingsIconLucide size={28} className="mx-0.5" style={{ color: "var(--themePrimaryColor, #312110)" }} />}
                    text="Settings"
                    active={location.pathname === '/PromotionUpload' || location.pathname === '/Settings'}
                >
                    <Link to="/Settings" className="w-full text-left px-2 py-1 hover:bg-[var(--themeSecondaryColor, #f4ecd6)] rounded transition-colors text-sm">App Settings</Link>
                    <Link to="/PromotionUpload" className="w-full text-left px-2 py-1 hover:bg-[var(--themeSecondaryColor, #f4ecd6)] rounded transition-colors text-sm">Promotions</Link>
                </SidebarItemGroup>

            </Sidebar>
            <div className="home-content flex-1">
                <nav className='home-content-nav flex flex-row p-2 mb-50' style={{ display: 'flex', alignItems: 'center' }}>
                    <div className="flex-1" style={{ color: "var(--themePrimaryColor, #DA6E0B)" }}>
                        <p style={{ margin: 0, fontWeight: 600 }}>Hello, {kiosk_details?.name}</p>
                    </div>
                    <div className="flex items-center space-x-3" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <IconButton
                            onClick={handleMenuClick}
                            sx={{
                                backgroundColor: 'white',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                                '&:hover': { backgroundColor: '#f5f5f5' },
                                width: '45px',
                                height: '45px'
                            }}
                        >
                            <img
                                src="/icons/tabler-icon-menu-2.png"
                                alt="Menu"
                                style={{ width: '24px', height: '24px' }}
                                onError={(e) => { e.target.style.display = 'none'; }} // Fallback if icon missing
                            />
                            {/* Fallback to Lucide icon if image fails */}
                            <div className="flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#75623F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="4" x2="20" y1="12" y2="12"></line><line x1="4" x2="20" y1="6" y2="6"></line><line x1="4" x2="20" y1="18" y2="18"></line></svg>
                            </div>
                        </IconButton>
                    </div>

                </nav>


                <div className='box-border h-full'>
                    <Outlet />
                </div>
            </div>

            {/* Dropdown Menu */}
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleMenuClose}
                PaperProps={{
                    sx: {
                        borderRadius: '16px',
                        mt: 1.5,
                        width: '280px',
                        boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.1)',
                        padding: '10px'
                    }
                }}
            >
                <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                    <img
                        src={kiosk_details?.logo || kiosk_details?.image || "https://yt3.googleusercontent.com/RlgPneEAZBw67tgsuNDnDbs3JTvffm2mhE31mxpSLbNVBOA7mPWVsdHe-EBApvrTM2krFkujjQ=s160-c-k-c0x00ffffff-no-rj"}
                        alt="Company Logo"
                        style={{ width: '80px', height: '80px', objectFit: 'contain', marginBottom: '12px' }}
                    />
                    <Typography variant="h6" sx={{ fontWeight: 700, color: '#3B362A', fontSize: '1.1rem', mb: 0.5 }}>
                        {kiosk_details?.name || 'Kiosk Name'}
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#999', fontSize: '0.8rem', mb: 0.2 }}>
                        Kiosk Mail:
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#999', fontSize: '0.85rem', wordBreak: 'break-all' }}>
                        {kiosk_details?.email || 'kiosk@example.com'}
                    </Typography>
                </Box>

                <Divider sx={{ my: 1, borderStyle: 'dashed' }} />

                <MenuItem
                    onClick={handleLogoutClick}
                    sx={{
                        borderRadius: '12px',
                        mx: 1,
                        my: 0.5,
                        py: 1.5,
                        '&:hover': {
                            backgroundColor: '#FEF2F2'
                        }
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', gap: 2 }}>
                        <img
                            src="https://aiwellassets.s3.ap-south-1.amazonaws.com/log+out+icon.png"
                            alt="Logout Icon"
                            style={{ width: '24px', height: '24px' }}
                        />
                        <Typography sx={{ fontWeight: 600, color: '#FF3B30', fontSize: '0.95rem' }}>
                            Logout
                        </Typography>
                    </Box>
                </MenuItem>
            </Menu>

            {/* Logout Confirmation Dialog */}
            <Dialog open={logoutOpen} onClose={handleCancel}>
                <DialogTitle>Confirm Logout</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to log out?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancel} color="primary">No</Button>
                    <Button onClick={handleConfirmLogout} color="error" autoFocus>Yes, Logout</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default Home;